import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { Type } from '../Type/Type';
import styles from './Accent.module.less';

/**
 * The Accent component helps emphasize content with ALL CAPS, but has restrictions.
 *
 * -   Accent (default) is reserved for Buttons – do not use Accent (default) in any other context
 * -   Accent Small anchors blocks of content, highlights elements in a dense table of data, or
 *     signals navigation in specific contexts (i.e., eyebrows via [ContentPageHeader](/?path=/docs/display-content-page-header) or [Tabs](/?path=/docs/navigation-tabs)) – use sparingly
 * -   Limit to short strings of a few words; capitals have reduced legibility
 */
export var Accent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref2;

  var align = _ref.align,
      children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'span' : _ref$component,
      inline = _ref.inline,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return /*#__PURE__*/React.createElement(Type, {
    align: align,
    fontFamily: "gotham",
    bold: true,
    className: classNames([(_ref2 = {}, _defineProperty(_ref2, styles['accent-small'], size === 'small'), _defineProperty(_ref2, styles.accent, size === 'default'), _ref2)]),
    component: component,
    inline: inline,
    ref: ref,
    uppercase: true
  }, children);
});
Accent.displayName = 'Accent';